import { FC } from 'react';
import { Modal } from 'ncoded-component-library';
import CampaignForm from './components/CampaignForm';
import { useCampaignSubmit } from './hooks';
import { CampaignFormType } from './components/CampaignForm/CampaignForm.component';
import useQueryParams from 'hooks/useQueryParams';
import { CampaignType } from 'models/Campaign';

type CampaignModalProps = {
  mode: 'edit' | 'create';
  initialValues?: Partial<CampaignFormType>;
  isOpen: boolean;
  onClose: () => void;
};

const CampaignModal: FC<CampaignModalProps> = (props) => {
  const { mode, initialValues, isOpen, onClose } = props;
  const { params } = useQueryParams();
  const { handleSubmit, isPendingUpdate } = useCampaignSubmit({
    mode,
    initialValues,
    onClose,
    isPersonal: params?.campaignType === CampaignType.Personal,
  });

  return (
    <Modal
      title={mode === 'edit' ? 'Edit campaign' : 'Create campaign'}
      open={isOpen}
      onClose={onClose}
    >
      <CampaignForm
        initialValues={initialValues}
        submitInProgress={isPendingUpdate}
        onSubmit={handleSubmit}
        mode={mode}
      />
    </Modal>
  );
};

export default CampaignModal;
